import style from "./UpdatePassword.module.css";
import Input from "../input/Input";
import Logo from "../../assets/images/logo.png";
import { useEffect, useState } from "react";
import validateInput from "../../utilities/validations/validateInput";
import { preAuth } from "../../stores/slices/preAuthSlice";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import {
  validateURL,
  updatePassService,
  resetpasswordUpdate,
} from "../../stores/slices/updatePasswordSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../menu/Loader";
import { language } from "../../stores/slices/languageSlice";
import { getRegistrationTokenPPP, getUserData, updatePasswordAPI } from "../../utilities/API/supertokenServices";
import { PARTNER_AUTH, PARTNER_BROWSER_ID } from "../../constant/Constants";
import { supertokenRevokeService } from "../../stores/slices/supertokens/supertokenRevokeSlice";
import { passworlessSignUpService } from "../../stores/slices/supertokens/passwordlessSignUpSlice";

const UpdatePassword = () => {
  const selectedLanguage = useSelector(language).updatePassword;
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const preAuthdetail = useSelector((state) => state.preAuthSlice);
  const updatePasswordDetails = useSelector(
    (state) => state.updatePasswordSlice
  );
  const [loader, setLoader] = useState(false)
  const [searchParam] = useSearchParams();
  let getHashValue = searchParam.get("p");
  let paramName = searchParam.get("p2");
  const token = searchParam.get('token');
  const email = searchParam.get('email');
  const id = searchParam.get('id');

  const [updatePassword, setUpdatePassword] = useState({
    Password: {
      value: "",
      isValid: true,
    },
    Confirm_Password: {
      value: "",
      isValid: true,
    },
  });
  const onChangePassword = (e) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let fieldvalidation = e.target.getAttribute("fieldvalidation");
    let inputValidate = validateInput(inputValue, fieldvalidation);
    if (name == "Confirm_Password") {
      if (updatePassword.Password.value != "") {
        setUpdatePassword((prevState) => ({
          ...prevState,
          Password: {
            value: updatePassword.Password.value,
            isValid: validateInput(updatePassword.Password.value, "password").isValid,
          },
        }));
      }
    } else {
      if (updatePassword.Confirm_Password.value != "") {
        setUpdatePassword((prevState) => ({
          ...prevState,
          Confirm_Password: {
            value: updatePassword.Confirm_Password.value,
            isValid: validateInput(updatePassword.Confirm_Password.value, "password").isValid,
          },
        }));
      }
    }
    setUpdatePassword((preinfo) => ({
      ...preinfo,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };
  const submitPassword = async () => {
    setLoader(true)
    let passwordValidate =
      updatePassword.Password.value != "" &&
      updatePassword.Password.isValid &&
      updatePassword.Confirm_Password.value != "" &&
      updatePassword.Confirm_Password.isValid;
    if (
      (updatePassword.Password.value != "" &&
        updatePassword.Confirm_Password.value == "") ||
      (updatePassword.Password.value == "" &&
        updatePassword.Confirm_Password.value != "")
    ) {
      setLoader(false)
      setUpdatePassword((prevState) => ({
        ...prevState,
        Password: {
          value: updatePassword.Password.value,
          isValid:
            updatePassword.Password.value != "" &&
            updatePassword.Password.isValid
              ? true
              : false,
        },
        Confirm_Password: {
          value: updatePassword.Confirm_Password.value,
          isValid:
            updatePassword.Confirm_Password.value != "" &&
            updatePassword.Confirm_Password.isValid
              ? true
              : false,
        },
      }));
      toast.error(selectedLanguage?.toastError);
    } else if (
      updatePassword.Password.value != "" &&
      updatePassword.Confirm_Password.value != ""
    ) {
      if (
        updatePassword.Password.value.trim() ===
        updatePassword.Confirm_Password.value.trim()
      ) {
        if (passwordValidate) {
          // if (updatePasswordDetails?.passwordData?.responsCode == "010") {
            const updatePasswordData = await updatePasswordAPI(token,  updatePassword.Password.value)
            if (updatePasswordData.status == "OK") {
                const getUsers = await getUserData(id)
                if (getUsers.loginMethods.length > 1) {
                    // await dispatch(supertokenRevokeService(id))
                    // storeDashboard.SuccessMessage = "PasswordUpdated"
                    setLoader(false)
                    navigate("/passswordSuccess");
                } else {
                    // await dispatch(supertokenRevokeService(id))
                    await  dispatch(passworlessSignUpService(email))
                    // storeDashboard.SuccessMessage = "PasswordUpdated"
                    setLoader(false)
                    navigate("/passswordSuccess");
                }
            } else if (updatePasswordData.status == "RESET_PASSWORD_INVALID_TOKEN_ERROR") {
              setLoader(false)
                toast.error("Hash value is incorrect ")
                navigate('/Login');
            } else {
              setLoader(false)
              toast.error(updatePasswordData.status)
              navigate('/Login');
            }
                // dispatch(
                //   updatePassService({
                //     BrowserId: PARTNER_BROWSER_ID.ID,
                //     password: updatePassword.Password.value,
                //     getHashValue,
                //     authorization: PARTNER_AUTH.Authorization,
                //   })
                // );
          // }
        } else {
          setLoader(false)
          setUpdatePassword((prevState) => ({
            ...prevState,
            Password: {
              value: updatePassword.Password.value,
              isValid:
                updatePassword.Password.value != "" &&
                updatePassword.Password.isValid
                  ? true
                  : false,
            },
            Confirm_Password: {
              value: updatePassword.Confirm_Password.value,
              isValid:
                updatePassword.Confirm_Password.value != "" &&
                updatePassword.Confirm_Password.isValid
                  ? true
                  : false,
            },
          }));
          // toast.error(selectedLanguage?.inValidPasswordError);
          toast.error("Create a valid password");
        }
      } else {
        setUpdatePassword((prevState) => ({
          ...prevState,
          Password: {
            value: updatePassword.Password.value,
            isValid: updatePassword.Password.value != "" && updatePassword.Password.isValid,
          },
          Confirm_Password: {
            value: updatePassword.Confirm_Password.value,
            isValid: updatePassword.Confirm_Password.value != "" && updatePassword.Confirm_Password.isValid,
          },
        }));
        setLoader(false)
        dispatch(resetpasswordUpdate())
          toast.error(selectedLanguage?.notMatchTostMsg);}
    } else {
      setLoader(false)
      setUpdatePassword((prevState) => ({
        ...prevState,
        Password: {
          value: updatePassword.Password.value,
          isValid: false,
        },
        Confirm_Password: {
          value: updatePassword.Confirm_Password.value,
          isValid: false,
        },
      }));
      toast.error(selectedLanguage?.toastErrorMsg);
    }
  };

  useEffect(() => {
      getRegistrationTokenPPP(preAuthRes)
  }, [preAuthdetail?.apiresponse]);
  const preAuthRes =()=>{
    // dispatch(
    //   validateURL({
    //     BrowserId: PARTNER_BROWSER_ID.ID,
    //     getHashValue,
    //     authorization:PARTNER_AUTH.Authorization,
    //   })
    // );
  }
  if (updatePasswordDetails?.passwordData?.navigate) {
    navigate("/");
  }
  if (updatePasswordDetails?.passwordData?.passwordUpdateSccess) {
    navigate("/passswordSuccess");
  }

  return (
    <>
      <div
        className={`${style.basic_container} d-flex justify-content-center `}
      >
        <div className={`${style.update_page}`}>
          <div className=" d-flex justify-content-center pt-5">
            {" "}
            <img src={Logo} alt="logo" />
          </div>
          <div className="container d-flex justify-content-center ">
            <p className={`pt-8 ${style.welcom_title}`}>
              {selectedLanguage?.wellcomeMsg}
            </p>
          </div>
          <div className="container d-flex justify-content-center ">
            <h2 className={`pt-6 ${style.heder_title}`}>
              {selectedLanguage?.passwordRequrdMsg}
            </h2>
          </div>
          <div className={`${style.pass_content}`}>
            <div className="container">
              <ul className="pt-3 list-disc">
                <li>{selectedLanguage?.passwordInstructions1}</li>
                <li>{selectedLanguage?.passwordInstructions2}</li>
                <li>{selectedLanguage?.passwordInstructions3}
                <ol className="p-3">
                  <li>{selectedLanguage?.condiction1}</li>
                  <li>{selectedLanguage?.condiction2}</li>
                  <li>{selectedLanguage?.condiction3}</li>
                  <li>{selectedLanguage?.condiction4}</li>
                </ol>
                </li>
              </ul>
              {/* <p className="pt-3">
                {selectedLanguage?.passwordInstructions1}
                <br />
                {selectedLanguage?.passwordInstructions2}
                <br />
                {selectedLanguage?.passwordInstructions3}
                <br />
              </p> */}
            </div>
            <div className="row p-3">
              <div className={`col-md-10 text-start ${style.pass_sugg}`}>
                {/* <ol>
                  <li>{selectedLanguage?.condiction1}</li>
                  <li>{selectedLanguage?.condiction2}</li>
                  <li>{selectedLanguage?.condiction3}</li>
                  <li>{selectedLanguage?.condiction4}</li>
                </ol> */}
                {/* <p>{selectedLanguage?.condiction1}</p>
                <p>{selectedLanguage?.condiction2}</p>
                <p>{selectedLanguage?.condiction3}</p>
                <p>{selectedLanguage?.condiction4} </p> */}
              </div>
            </div>
          </div>
          <div className="container d-flex justify-content-center ">
            <div className={`${style.input_fields}`}>
              <Input
                type="password"
                id="Password"
                name="Password"
                label={selectedLanguage?.password}
                value={updatePassword.Password.value}
                onChange={(e) => onChangePassword(e)}
                isValid={updatePassword.Password.isValid}
                fieldvalidation="password"
                errorMsg={selectedLanguage?.errorMsg}
              />
            </div>
          </div>
          <div className="container d-flex justify-content-center ">
            <div className={`${style.input_fields}`}>
              <Input
                type="password"
                id="ConfirmPassword"
                name="Confirm_Password"
                label={selectedLanguage?.confirmPassword}
                value={updatePassword.Confirm_Password.value}
                onChange={(e) => onChangePassword(e)}
                isValid={updatePassword.Confirm_Password.isValid}
                fieldvalidation="password"
                errorMsg={selectedLanguage?.errorMsg}
              />
            </div>
          </div>
          <div className="pt-8 pb-8 d-flex justify-content-center">
            <button onClick={submitPassword} className={`btn ${style.buttons}`}>
              {selectedLanguage?.updatePassword}
            </button>
          </div>
        </div>
      </div>
      {updatePasswordDetails?.passwordData?.loader == true || loader ? <Loader /> : null}
    </>
  );
};

export default UpdatePassword;
